<template>
    <base-dialog :loading="loading" :value="dialog" :title="dialogTitle" :width="480" @input="onDialogInput" @close="hide">
        <v-row dense>
            <v-col cols="12">
                <kimsa-text-field :label="$t('common.date')" @change="date = $event" :value="date" dense no-elevation
                    readonly />
            </v-col>
            <v-col cols="12">
                <kimsa-text-field :label="$t('common.activity')" @change="name = $event" :value="name" dense
                    no-elevation />
            </v-col>
            <v-col cols="12">
                <kimsa-text-field :label="$t('common.time')" @change="time = $event" :value="time" dense
                    no-elevation />
            </v-col>
            <v-col cols="12">
                <kimsa-text-field :label="$t('common.intensity')" @change="intensity = $event" :value="intensity" dense
                    no-elevation />
            </v-col>
        </v-row>
        <template #footer>
            <v-btn class="footer-btn" depressed block :disabled="disabled" @click="save" :loading="loading">
                {{ $t('common.save') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>
import { db, Timestamp } from "@/utils/Firebase";
import { sendMessage } from "@/utils/Messages";
import KimsaTextField from '../common/inputs/KimsaTextField.vue';
import BaseDialog from "@/components/common/BaseDialog";

export default {
    name: "AddActivityDialog",
    components: { KimsaTextField, BaseDialog },
    data() {
        return {
            dialog: false,
            loading: false,
            date: this.$moment().format('DD-MM-YYYY'),
            name: '',
            time: '',
            intensity: ''
        }
    },
    computed: {
        dialogTitle(vm = this) {
            return `${vm.$t('common.add')} ${vm.$t('common.activity')}`
        },
        disabled(vm = this) {
            return !vm.name || !vm.time || !vm.intensity
        },
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        onDialogInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.date = vm.$moment().format('DD-MM-YYYY')
            vm.name = ''
            vm.time = ''
            vm.intensity = ''
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                let studentId = vm.currentUser?.uid || null
                let coachId = vm.account?.studentSubscription?.coachId || null

                await db.collection('activities').add({
                    studentId: studentId,
                    coachId: coachId,
                    type: 'activity',
                    date: vm.$moment(vm.date, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    name: vm.name,
                    time: vm.time,
                    intensity: vm.intensity,
                    createdAt: Timestamp.now(),
                })

                await vm.sendMessageToCoach()
                vm.toast(vm.$t('common.activity_sent'))

                vm.hide()
            })
        },
        async sendMessageToCoach() {
            const vm = this

            let message = `${vm.$t('common.recorded_activity')} \n${vm.$t('common.date')}: ${vm.date} \n${vm.$t('common.name')}: ${vm.name} \n${vm.$t('common.time')}: ${vm.time} \n${vm.$t('common.intensity')}: ${vm.intensity}`

            let studentId = vm.currentUser?.uid || null
            let coachId = vm.account?.studentSubscription?.coachId || null

            await sendMessage({ message, from: studentId }, coachId, studentId)
        },
    },
}
</script>

<style scoped>
.footer-btn.v-btn {
    height: 52px !important;
    border-radius: 0 !important;
    text-transform: none;
    letter-spacing: normal;
    font-weight: 700;
    box-shadow: none !important;
    background: var(--v-primary-base) !important;
    color: #0C0E12 !important;
}

.footer-btn.v-btn.v-btn--disabled {
    background: var(--v-surface2-base) !important;
    color: var(--v-txtMuted-base) !important;
}
</style>
